
import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'

// 服务组件映射表
const ServiceComponentMap: { [key: string]: () => Promise<any> } = {
  // PDF/图片转Word服务
  pdfImgToDocx: () => import('./services/PdfImgToDocxPage.vue'),
  pdfImgToDocxTool: () => import('./services/PdfImgToDocxPage.vue'),

  // 课件制作服务
  editableCourseWare: () => import('./services/EditableCourseWarePage.vue'),

  // 内容数字化
  questionBank: () => import('./services/QuestionBankPage.vue'),

  // 学转教服务
  studentToTeacher: () => import('./services/StudentToTeacherPage.vue'),

  // 方正转word
  fbdToWord: () => import('./services/FbdToWordPage.vue'),

  // ppt转希沃
  pptToEnbx: () => import('./services/PptToEnbxPage.vue'),

  // Word自动排版
  wordToFbd_auto: () => import('./services/WordToFbdPage.vue'),

  // Word转PPT
  wordToPpt: () => import('./services/WordToPptPage.vue'),

  // JSON转PPT
  jsonToPpt: () => import('./services/JsonToPptPage.vue'),

  // AI编辑
  ai_edit: () => import('./services/AiEditPage.vue'),

  // AI校对
  ai_check: () => import('./services/AiEditPage.vue'),

  // 默认服务组件，用于处理未特殊定制的服务类型
  default: () => import('./BasePage.vue'),
}

Component.registerHooks(['beforeRouteEnter'])
@Component({
  components: {},
})
export default class PlaceOrderRefactor extends Vue {
  currentComponent: any = null

  // 防止刷新之后丢失 params 参数
  beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    let { serviceType, name } = to.params
    if (!serviceType || !name) {
      serviceType = window.sessionStorage.getItem('service_type')!
      name = window.sessionStorage.getItem('service_name')!
    }
    to.params.serviceType = serviceType
    to.params.name = name

    next((vm: { initComponent: (arg0: string, arg1: string) => void }) => {
      vm.initComponent(serviceType, name)
    })
  }

  async created() {
    if (this.$route.query && this.$route.query.service_type && this.$route.query.service_name) {
      window.sessionStorage.setItem('service_type', this.$route.query.service_type as string)
      window.sessionStorage.setItem('service_name', this.$route.query.service_name as string)
    }
  }

  // 初始化组件
  async initComponent(serviceType: string) {
    try {
      // 根据服务类型动态加载对应组件
      const componentLoader = ServiceComponentMap[serviceType] || ServiceComponentMap['default']
      const component = await componentLoader()
      this.currentComponent = component.default
    } catch (error) {
      console.error('加载服务组件失败:', error)
    }
  }
}
